<template>
    <header class="flex_r_center">
        <div class="header flex_r">
            <a href="/">
                <img :src="src" alt="">
            </a>
            <div class="tags flex_r_between">
                <div @click="goRoute(item.route)"  v-for="(item,index) in tagArr" :key="index" :class="[($route.path.indexOf(item.route)>-1&&userInfo.uid==$route.params.uid)&&'router-link-active']" class="tag">{{item.name}}</div>
            </div>
            <div @keyup.enter="search" class="search flex0 flex_r">
                <input type="text" v-model='kw' placeholder="搜索档案标题或作者" class="input">
                <SvgIcon @click.native="search" name='search'  />
            </div>
            <div @click="$router.push({name: 'myindex', params:{uid:userInfo.uid}})" v-if='userInfo.name&&userInfo.uid' class="user flex0 flex_r">
                <img :src="userInfo.logo" alt="头像">
                <div class="name f20">{{userInfo.name}}</div>
            </div>
            <div v-else @click="$isLogin" class="user flex0">
                登录/注册
            </div>
            
        </div>
    </header>
</template>
<script>
import { mapState} from 'vuex'
export default {
    name: 'myHeader',
    data(){
        return {
            src: require('../../public/logo.png'),
            tagArr: [
                {
                  name: '推荐',
                  route: '/home'  
                },
                {
                    name: '分类',
                    route: '/category'
                },
                {
                    name: '回音檐廊',
                    route: '/echo'
                },
                {
                    name: '发布档案',
                    route: '/files'
                },
                {
                    name: '个人中心',
                    route: '/my'
                }
            ],
            kw: ''
        }
    },
    computed:{
        ...mapState(['userInfo'])
    },
    mounted(){
       
    },
    methods: {
        search(){
            let kw = this.kw;
            this.$router.push('/category?kw='+ kw)
        },
        goRoute(url){
            if(url=='/my'){
                let uid = this.$isLogin();
                if(!uid)return
                return this.$router.push({
                    name: 'myindex',
                    params: {
                        uid
                    }
                })
            }
            this.$router.push(url)
        },
    }
}
</script>
<style lang="less" scoped>
header{
    min-width: 1200px;
    border-bottom: 2px solid #FAFAFA;
    .header{
        width: 1200px;
        height: 80px;
        a{
            img{
                width: 120px;
                height: 80px;
            }
        }
        .tags{
            margin-left: 150px;
            .tag{
                height: 80px;
                padding: 0 16px;
                white-space: nowrap;
                text-align: center;
                line-height: 80px;
                font-weight: 600;
                font-size: 20px;
                color: #2D2121;
                &.active{
                    color: #AD2729;
                    box-sizing: border-box;
                    border-bottom: 4px solid #AD2729;
                }
            }
        }
        .search{
            width: 250px;
            height: 40px;
            margin-left: 12px;
            padding: 9px 12px;
            box-sizing: border-box;
            background: #FAFAFA;
            border-radius: 20px;
            border: 1px solid #E6E6E6;
            input{
                width: 100%;
                height: 100%;
                font-size: 16px;
                background: transparent;
                &::placeholder{
                    color: #958F8F;
                }
            }
            .svg-icon--search{
                font-size: 24px;
                color: #AD2729;
            }
        }
        .user{
            font-size: 20px;
            color: #574B4B;
            margin-left: 30px;
            cursor: pointer;
            img{
                width: 36px;
                height: 36px;
                margin-right: 8px;
                border-radius: 50%;
            }
        }
    }
    
}
.router-link-active {
    color: #AD2729;
    box-sizing: border-box;
    border-bottom: 4px solid #AD2729;
}
</style>